import { InjectionToken } from '@angular/core';

/** Route path `v1RootGuard` redirects to when the URL is a bare `/` with no fragment. Provide explicitly in each app's bootstrap. */
export const V1_ROOT_FALLBACK = new InjectionToken<string>('V1_ROOT_FALLBACK');
